interface CatLoaderProps {
  message?: string;
  fullPage?: boolean;
}

export default function CatLoader({ message = 'Carregando...', fullPage = false }: CatLoaderProps) {
  const content = (
    <div className="flex flex-col items-center justify-center gap-4 py-10">
      <div className="w-36 h-36 flex items-center justify-center overflow-hidden rounded-2xl">
        <img
          src="https://i.pinimg.com/originals/43/f9/32/43f932252dd3a97691bf754b989e2a77.gif"
          alt="Gatinho brincando com a bolinha"
          className="w-full h-full object-cover"
          onError={(e) => {
            const target = e.currentTarget as HTMLImageElement;
            target.style.display = 'none';
            const parent = target.parentElement;
            if (parent) {
              parent.innerHTML = '<span style="font-size:4rem">🐱</span>';
            }
          }}
        />
      </div>
      <p className="text-foreground-500 text-sm font-medium animate-pulse">{message}</p>
    </div>
  );

  if (fullPage) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        {content}
      </div>
    );
  }

  return content;
}